import React from "react";
import { createRoot } from "react-dom/client";
import BasicDialog from "./BasicDialog";
import { colorPrimary } from "../../Styles/Colors";

 
export const dialogAlert = (message, type = "info", title = null) => {
 
  const container = document.createElement("div");
  document.body.appendChild(container);
  const root = createRoot(container);
 
  const closeDialog = () => {
    root.unmount();
    if (container.parentNode === document.body) {
      document.body.removeChild(container);
    }
  };
 
  const getTypeConfig = () => {
    switch (type) {
      case "success":
        return {
          title: title || "Success",
          type: "success",
        };
      case "error":
        return {
          title: title || "Error",
          type: "error",
        };
      case "warning":
        return {
          title: title || "Warning",
          type: "warning",
        };
      case "info":
      default:
        return {
          title: title || "Information",
          type: "info",
        };
    }
  };

  const config = getTypeConfig();
 
  root.render(
    <BasicDialog
      open={true}
      onClose={closeDialog}
      title={config.title}
      content={message}
      type={config.type}
      actions={[
        {
          label: "OK",
          variant: "contained",
          color: colorPrimary,
          onClick: closeDialog,
        },
      ]}
    />
    
  );
};
 
export const successAlert = (message, title) =>
  dialogAlert(message, "success", title);
export const errorAlert = (message, title) =>
  dialogAlert(message, "error", title);
export const warningAlert = (message, title) =>
  dialogAlert(message, "warning", title);
export const infoAlert = (message, title) =>
  dialogAlert(message, "info", title);

 
export const dialogConfirm = (message, onConfirm, title = "Confirm") => {
  const container = document.createElement("div");
  document.body.appendChild(container);
  const root = createRoot(container);

  const closeDialog = () => {
    root.unmount();
    if (container.parentNode === document.body) {
      document.body.removeChild(container);
    }
  };

  const handleConfirm = () => {
    closeDialog();
    if (onConfirm) onConfirm();
  };

  root.render(
    <BasicDialog
      open={true}
      onClose={closeDialog}
      title={title}
      content={message}
      type="warning"
      actions={[
        {
          label: "Cancel",
          variant: "outlined",
          color: "secondary",
          onClick: closeDialog,
        },
        {
          label: "Confirm",
          variant: "contained",
          color: "primary",
          onClick: handleConfirm,
        },
      ]}
    />
  );
};
